import * as R from 'ramda';
import { LOCALES } from '@bagonboard/wiseman';

import { filterRolesToShow } from './logic';

export const defaultNoValueList = [{ value: '', text: '-- No value --' }];

export const parsePois = (pois = [], currentLang) => {
  if (R.isEmpty(pois)) {
    return defaultNoValueList;
  }
  const isValidLocale = Object.keys(LOCALES).includes(currentLang);
  const buildDescription = (code, description) => {
    const descrip = description && description[isValidLocale ? currentLang : LOCALES.en];
    return `${code} ${descrip && `- ${descrip}`}`;
  };
  return pois.map(
    ({
      _id, description, code,
    }) => ({
      value: _id,
      text : buildDescription(code, description),
    })
  );
};

export const parseTerminals = (poiId, pois = []) => {
  const poi = poiId && R.is(Array, pois) && R.find(R.propEq('_id', poiId))(pois);
  if (!poi) {
    return defaultNoValueList;
  }
  return R.pipe(
    R.path(['terminals']),
    R.map(({ number }) => ({
      value: number, text: number,
    }))
  )(poi);
};

export const parseAreas = (areas = []) => {
  if (!R.is(Array, areas) || R.isEmpty(areas)) {
    return defaultNoValueList;
  }
  return areas.map(R.applySpec({
    value: R.prop('_id'),
    text : R.prop('code'),
  }));
};

export const parseCompanies = (companies = []) => {
  if (!R.is(Array, companies) || R.isEmpty(companies)) {
    return defaultNoValueList;
  }
  return companies.map(
    ({
      _id, code, name, type = '',
    }) => ({
      value: _id,
      text : `${type.toUpperCase()} - ${code} - ${name}`,
    })
  );
};

export const parseUserRoles = (currentRole) => {
  if (!currentRole) {
    return defaultNoValueList;
  }
  const firstValue = {
    value: '',
    text : 'All',
  };
  const rolesToFilter = filterRolesToShow(currentRole, true);
  return [firstValue, ...rolesToFilter];
};
